import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import "./MeetingFile.css";

function MeetingFile({ data, downloadFile }) {
  return (
    <Col className="file-container">
      <Row className="justify-content-center align-items-center">
        <Col lg={12}>
          <p
            className="meeting-file"
            onClick={() => downloadFile(data.fileUrl)}
          >
            {data.fileName}
          </p>
        </Col>
      </Row>
    </Col>
  );
}

export default MeetingFile;
